import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout/layoutIndex.vue'
import Home from '../views/home.vue'

Vue.use(VueRouter)
const originalpush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
	return originalpush.call(this, location).catch(err => err);
}

const routes = [{
		path: '/',
		name: 'main',
		component: Layout,
		redirect: '/home',
		children: [{
			path: '/home',
			name: 'Home',
			component: Home,
			meta: {
				isAuth: true,
				isMenu: true,
				title: '主页',
				icon: "",
				powerCode: ''
			}
		}]
	},
	{
		path: '*',
		redirect: '/' // 重定向到首页或其他默认页面
	}, {
		path: '/login',
		name: 'login',
		component: () => import('../views/login/index.vue'),
	},
	{
		path: '/userManage',
		component: Layout,
		redirect: '/userManage',
		meta: {
			isAuth: true,
			isMenu: true,
			title: '系统管理',
			icon: 't-icon t-icon-xitongguanli'
		},
		children: [{
				path: '/userList',
				name: 'userList',
				component: () => import('../views/system/user/userIndex.vue'),
				power_code: 'YHLB',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '用户列表',
					icon: 't-icon t-icon-yonghuliebiao'
				}
			},
			{
				path: '/roleList',
				name: 'roleList',
				component: () => import('../views/system/role/roleIndex.vue'),
				power_code: 'JSLB',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '角色列表',
					icon: 't-icon t-icon-jiaoseliebiao'
				}
			}, {
				path: '/menuList',
				name: 'menuList',
				component: () => import('../views/system/menu/menuIndex.vue'),
				power_code: 'CDLB',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '菜单列表',
					icon: 't-icon t-icon-caidanliebiao'
				}
			},
			{
				path: '/powerList',
				name: 'powerList',
				component: () => import('../views/system/power/index.vue'),
				power_code: 'QXLB',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '权限列表',
					icon: 't-icon t-icon-quanxianliebiao'
				}
			},
		]
	}, {
		path: '/basicSetting',
		component: Layout,
		redirect: '/basicSetting',
		meta: {
			isAuth: true,
			isMenu: true,
			title: '基础设置',
			icon: 't-icon t-icon-shezhi'
		},
		children: [{
				path: '/dictionaryList',
				name: 'dictionaryList',
				component: () => import('../views/basicSetting/dictionary/dictionaryIndex.vue'),
				power_code: 'SJZD',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '数据字典',
					icon: 't-icon t-icon-shujuzidian'
				}
			}, {
				path: '/productList',
				name: 'productList',
				component: () => import('../views/basicSetting/product/productIndex.vue'),
				power_code: 'SPXX',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '商品信息',
					icon: 't-icon t-icon-shangpinxinxi'
				}
			}, {
				path: '/infomercialList',
				name: 'infomercialList',
				component: () => import('../views/basicSetting/infomercial/infomercialInfoIndex.vue'),
				power_code: 'GGXX',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '广告信息',
					icon: 't-icon t-icon-guanggaoxinxi'
				}
			},
			// {
			// 	path: '/raffleList',
			// 	name: 'raffleList',
			// 	component: () => import('../views/basicSetting/raffle/raffleInfoIndex.vue'),
			// 	power_code: 'CJXX',
			// 	meta: {
			// 		isAuth: true,
			// 		isMenu: true,
			// 		title: '抽奖信息',
			// 		icon: 't-icon t-icon-choujiangxinxi'
			// 	}
			// }, 
		]
	}, {
		path: '/benefitsManage',
		component: Layout,
		redirect: '/benefitsManage',
		meta: {
			isAuth: true,
			isMenu: true,
			title: '权益管理',
			icon: 't-icon t-icon-quanyiguanli'
		},
		children: [{
			path: '/benefitsItemList',
			name: 'benefitsItemList',
			component: () => import('../views/benefits/benefitsItem/benefitsItemIndex.vue'),
			power_code: 'QYXXX',
			meta: {
				isAuth: true,
				isMenu: true,
				title: '权益项信息',
				icon: 't-icon t-icon-quanyixiang'
			}
		}, {
			path: '/benefitsInfoList',
			name: 'benefitsInfoList',
			component: () => import('../views/benefits/benefitsInfo/benefitsInfoIndex.vue'),
			power_code: 'HYQY',
			meta: {
				isAuth: true,
				isMenu: true,
				title: '会员权益',
				icon: 't-icon t-icon-huiyuanquanyi'
			}
		}, {
			path: '/benefitsProductList',
			name: 'benefitsProductList',
			component: () => import('../views/benefits/benefitsProduct/benefitsProductIndex.vue'),
			power_code: 'QYSP',
			meta: {
				isAuth: true,
				isMenu: true,
				title: '权益商品',
				icon: 't-icon t-icon-quanyishangpin'
			}
		}]
	}, {
		path: '/certificateManage',
		component: Layout,
		redirect: '/certificateManage',
		meta: {
			isAuth: true,
			isMenu: true,
			title: '证书管理',
			icon: 't-icon t-icon-zhengshuguanli'
		},
		children: [
			// 	{
			// 	path: '/certificateTypeList',
			// 	name: 'certificateTypeList',
			// 	component: () => import('../views/certificate/certificateTypeIndex.vue'),
			// 	power_code: 'ZSLX',
			// 	meta: {
			// 		isAuth: true,
			// 		isMenu: true,
			// 		title: '证书类型',
			// 		icon: 't-icon t-icon-zhengshuleixing'
			// 	}
			// }, 
			{
				path: '/certificateInfoList',
				name: 'certificateInfoList',
				component: () => import('../views/certificate/certificateInfoIndex.vue'),
				power_code: 'ZSXX',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '证书信息',
					icon: 't-icon t-icon-zhengshuxinxi'
				}
			}
		]
	}, {
		path: '/scheduleManage',
		component: Layout,
		redirect: '/scheduleManage',
		meta: {
			isAuth: true,
			isMenu: true,
			title: '日程管理',
			icon: 't-icon t-icon-richengguanli'
		},
		children: [{
			path: '/scheduleInfoInfoList',
			name: 'scheduleInfoInfoList',
			component: () => import('../views/schedule/scheduleInfoIndex.vue'),
			power_code: 'RCXX',
			meta: {
				isAuth: true,
				isMenu: true,
				title: '日程信息',
				icon: 't-icon t-icon-richenxinxi'
			}
		}]
	},
	{
		path: '/appletUserManage',
		component: Layout,
		redirect: '/appletUserManage',
		meta: {
			isAuth: true,
			isMenu: true,
			title: '会员管理',
			icon: 't-icon t-icon-huiyuanguanli'
		},
		children: [{
			path: '/appletUserList',
			name: 'appletUserList',
			component: () => import('../views/appletUser/userList.vue'),
			power_code: 'HYLB',
			meta: {
				isAuth: true,
				isMenu: true,
				title: '会员信息',
				icon: 't-icon t-icon-huiyuanxinxi'
			}
		}]
	},
	{
		path: '/orderManage',
		component: Layout,
		redirect: '/orderManage',
		meta: {
			isAuth: true,
			isMenu: true,
			title: '订单管理',
			icon: 't-icon t-icon-dingdanguanli'
		},
		children: [{
			path: '/orderList',
			name: 'orderList',
			component: () => import('../views/order/orderIndex.vue'),
			power_code: 'DDLB',
			meta: {
				isAuth: true,
				isMenu: true,
				title: '订单信息',
				icon: 't-icon t-icon-dingdanxinxi'
			}
		}]
	},
	{
		path: '/appletManage',
		component: Layout,
		redirect: '/appletManage',
		meta: {
			isAuth: true,
			isMenu: true,
			title: '小程序管理',
			icon: 't-icon t-icon-xiaochengxuguanli'
		},
		children: [{
			path: '/privacyContent',
			name: 'privacyContent',
			component: () => import('../views/applet/privacyContent.vue'),
			power_code: 'YSXLNR',
			meta: {
				isAuth: true,
				isMenu: true,
				title: '隐私协议',
				icon: 't-icon t-icon-yinsixieyi'
			}
		}]
	},
	{
		path: '/messagePushManage',
		component: Layout,
		redirect: '/messagePushManage',
		meta: {
			isAuth: true,
			isMenu: true,
			title: '消息推送',
			icon: 't-icon t-icon-xiaoxituisong'
		},
		children: [{
				path: '/messagePushSettings',
				name: 'messagePushSettings',
				component: () => import('../views/messagePush/messagePushSettingsIndex.vue'),
				power_code: 'XXMB',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '消息模板',
					icon: 't-icon t-icon-xiaoximoban'
				}
			},
			{
				path: '/scheduleTaskList',
				name: 'scheduleTaskList',
				component: () => import('../views/messagePush/scheduleTaskIndex.vue'),
				power_code: 'RWLB',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '任务列表',
					icon: 't-icon t-icon-renwuliebiao'
				}
			},
			{
				path: '/messagePushRecord',
				name: 'messagePushRecord',
				component: () => import('../views/messagePush/messagePushIndex.vue'),
				power_code: 'TSJL',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '推送记录',
					icon: 't-icon t-icon-xiaoxituisongliebiao'
				}
			}
		]
	},
	{
		path: '/enrollManage',
		component: Layout,
		redirect: '/enrollManage',
		meta: {
			isAuth: true,
			isMenu: true,
			title: '招生推广管理',
			icon: 't-icon t-icon-zhaoshengguanli'
		},
		children: [{
				path: '/schoolList',
				name: 'schoolList',
				component: () => import('../views/enrollmentPro/schoolInfo/schoolInfoIndex.vue'),
				power_code: 'SchoolLB',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '学校列表',
					icon: 't-icon t-icon-school'
				}
			},
			{
				path: '/educationStageList',
				name: 'educationStageList',
				component: () => import('../views/enrollmentPro/educationStage/educationStageIndex.vue'),
				power_code: 'SXJDLB',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '升学阶段列表',
					icon: 't-icon t-icon-shengxuejieduan'
				}
			},
			{
				path: '/enrollPersonnelList',
				name: 'enrollPersonnelList',
				component: () => import('../views/enrollmentPro/enrollPersonnel/enrollPersonnelIndex.vue'),
				power_code: 'TGRYLB',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '推广人员列表',
					icon: 't-icon t-icon-tuiguang'
				}
			},
			{
				path: '/enrollRecordList',
				name: 'enrollRecordList',
				component: () => import('../views/enrollmentPro/enrollRecord/enrollRecordIndex.vue'),
				power_code: 'TGJLLB',
				meta: {
					isAuth: true,
					isMenu: true,
					title: '推广记录列表',
					icon: 't-icon t-icon-renwuliebiao'
				}
			},
		]
	}
]



const router = new VueRouter({
	base: process.env.BASE_URL,
	//mode: 'history', // 设置为'history'模式
	routes,
});

router.beforeEach((to, from, next) => {
	if (to.meta.isAuth) {
		if (localStorage.access_token) {
			next();
		} else {
			next('/login');
		}
	} else {
		next();
	}
});


export default router;